
import {
  defineComponent,
  ref,
  onMounted,
  PropType,
  computed,
  watch,
} from "vue";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import { useStore } from "vuex";
import { useThemeVars, useDialog } from "naive-ui";
import { changeColor } from "seemly";
import {
  Module as HosterModule,
  Actions as HosterActions,
  Getters as HosterGetters,
} from "@/store/enums/hosterEnums";

import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply,
} from "@/store/enums/paramsEnums";

import { MdPerson, MdRemove } from "@vicons/ionicons4";
import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import inviteAvailableTimeCountModel from "@/core/models/hoster/inviteAvailableTimeCount.interface";
import voteEventModel from "@/core/models/share/voteEvent.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";

export default defineComponent({
  name: "hosterResponseModalResolution",
  props: {
    event: { type: Object as PropType<inviteEventModel | null> },
  },
  components: { MdPerson, MdRemove },
  setup(props: any, context: any) {
    const store = useStore();

    const personNone = computed(
      // () => store.getters[HosterModule.desc + HosterGetters.InvitMember]
      function () {
        let ori: Array<invitePersonModel> = store.getters[HosterModule.desc + HosterGetters.InvitMember]
        ori = ori.filter(
          (r:invitePersonModel) => r.Status == ParamParticapantStatus.None
        );

      // var result = eventResponse.value.filter((e: voteEventModel) => e.EventScheduleId == eventScheduleId && e.Status != null)
      let name = ori.map((a:invitePersonModel) => a.Name).join(', ');
      let count = ori.length;
      
        
      return { name:name, count: count , data: ori};
      }
    );

    const resolution = computed<inviteEventModel>(
      () => store.getters[HosterModule.desc + HosterGetters.Resolution]
    );
    const userResponseSummary = computed<Array<inviteAvailableTimeCountModel>>(
      () =>
        store.getters[HosterModule.desc + HosterGetters.EventSchedularWithCount]
    );
    const eventResponse = computed<Array<voteEventModel>>(() =>
        store.getters[
        HosterModule.desc +
        HosterGetters.EventResponse
            ]
    );
    function eventResponseFilter(eventScheduleId: string) {
      var result = eventResponse.value.filter((e: voteEventModel) => e.EventScheduleId == eventScheduleId && e.Status != null)
      let name = result.map((a) => a.Name).join(', ');
      
      return name
    }

    function percentage(numerator: number, denominator: number) {
      return Number(((numerator * 100) / denominator).toFixed(0));
    }

    function makedicision(value: string) {
      let item = userResponseSummary.value.find(
        (r) => r.EventScheduleId == value
      );
      let params = { ...props.event };
      params.Location = resolution.value.Location;
      params.FianlSchedularId = value;
      params.StartUTCDateTime = item?.ScheduleStartUTCDateTime;
      params.EndUTCDateTime = item?.ScheduleEndUTCDateTime;
      store.dispatch(
        HosterModule.desc + HosterActions.UpdateResolution,
        params
      );
    }

    function dateDisplay(date: string) {
      return dayjs( date).format("MM/DD ddd");
    }

    function startTimeDisplay(date: string) {
      return dayjs( date).format("HH:mm");
    }

    function endTimeDisplay(date: string) {
      return dayjs( date).format("HHmm") == "0000"
        ? "24:00"
        : dayjs( date).format("HH:mm");
    }

    return {
      userResponseSummary,
      percentage,
      resolution,
      themeVars: useThemeVars(),
      changeColor,
      makedicision,
      dateDisplay,
      startTimeDisplay,
      endTimeDisplay,
      eventResponseFilter,
      personNone,
      eventResponse
    };
  },
});
